import { render, staticRenderFns } from "./SubmitForm6.vue?vue&type=template&id=711d6fe0&scoped=true"
import script from "./SubmitForm6.vue?vue&type=script&lang=ts"
export * from "./SubmitForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d6fe0",
  null
  
)

export default component.exports